import React from 'react';
import classnames from 'classnames';
import { getIOSVersion } from '../../../../../../helpers/browserHelpers';
import Suggestions from './suggestions/suggestions';
import PopularProducts from './popularProducts/popularProducts';
import CloseButton from './closeButton/closeButton';
import useCalculateDropdownHeight from '../../hooks/useCalculateDropdownHeight';
import dropdownStyles from './dropdown.module.pcss';
import { AttraqtSuggestionsResponse } from '../../../../../../types';

const iosBottomBarHeight = 79;

interface DropdownProps {
  handleClose: () => void;
  handleEsc: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  open: boolean;
  data: AttraqtSuggestionsResponse | null;
  canDisplayDropdown: boolean;
  innerHeight: number;
  innerWidth: number;
}

function Dropdown({
  handleClose,
  handleEsc,
  handleBlur,
  open,
  data,
  canDisplayDropdown,
  innerHeight,
  innerWidth
}: DropdownProps): React.ReactElement {
  const iosversion = getIOSVersion();
  const ios15up = iosversion && iosversion >= 15;
  const { height, maxHeight } = useCalculateDropdownHeight(
    open,
    innerWidth,
    innerHeight,
    ios15up ? iosBottomBarHeight : 0
  );

  const heights = {
    height,
    maxHeight
  } as React.CSSProperties;

  return canDisplayDropdown && data ? (
    <div
      style={heights}
      className={dropdownStyles.dropdown}
      data-click-inside-search
      onKeyDown={handleEsc}
      role="presentation"
      onBlur={handleBlur}
    >
      <div className={classnames(dropdownStyles.dropdown__flex, { [dropdownStyles.ios15up]: ios15up })}>
        <div className={dropdownStyles['dropdown__close-button-wrapper']}>
          <CloseButton handleClick={handleClose} />
        </div>
        <div className={dropdownStyles['dropdown__suggestions-wrapper']}>
          {data.data.suggestion.searchTerms.length === 0 ? (
            <></>
          ) : (
            <Suggestions suggestions={data.data.suggestion.searchTerms} />
          )}
        </div>
        <div className={dropdownStyles['dropdown__delimiter']}>
          <div className={dropdownStyles['dropdown__delimiter-line']} />
        </div>
        <div className={dropdownStyles['dropdown__popular-products-wrapper']}>
          {data.data.suggestion.products.length === 0 ? (
            <></>
          ) : (
            <PopularProducts popularProducts={data.data.suggestion.products} />
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default Dropdown;
